import { useQuery } from "@tanstack/react-query";

import { ACTOR_VOICES_QUERY_KEYS } from "Actors/Api/Queries/actorVoicesQueryKeys";
import { getExternalVoicesSearch, type VoiceLlm } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";

export interface ExternalVoicesSearchParams {
  voiceLlm?: VoiceLlm;
  searchQuery?: string;
  offset?: number;
  limit?: number;
}

export function useExternalVoicesSearchQuery(
  params: ExternalVoicesSearchParams,
) {
  return useQuery({
    queryKey: ACTOR_VOICES_QUERY_KEYS.externalVoicesSearch(params),
    queryFn: processResponse(() =>
      getExternalVoicesSearch(
        params.voiceLlm,
        params.searchQuery,
        params.offset,
        params.limit,
      ),
    ),
    enabled: !!params.voiceLlm,
  });
}
